// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aDye","top":"styles_top__1fYlJ"};